/*
 * @Description: 
 * @Author: kangkang
 * @Date: 2022-06-21 21:24:02
 * @LastEditTime: 2023-04-11 23:44:01
 * @LastEditors: kangkang
 * @Reference: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/flexible'
import  './plugins/JSSdk'
import './plugins/vant'
import './plugins/components'
import axios from './plugins/axios'
import EventBus from './plugins/eventBus'
import qs from 'qs';
import api from './api';
import regular from './plugins/regular'
import utils from '@/plugins/utils'
import coordinate from '@/plugins/coordinate'
import md5 from 'js-md5';
import VueQriously from 'vue-qriously'
import moment from 'moment';
import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
import VueCanvasPoster from 'vue-canvas-poster'
import store from './store/index';
import loadingIndex from "@/plugins/loading"


if (process.env.NODE_ENV !== 'production') { // 测试和开发打开，生产不能打开
    let vConsole = new VConsole()
    Vue.use(vConsole)
}

Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.prototype.$utils = utils;
Vue.prototype.$coordinate = coordinate;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$qs = qs;
Vue.prototype.$api = api;
Vue.prototype.$regular = regular;
Vue.prototype.$domain = process.env.VUE_APP_API_URL;
Vue.prototype.$envname = process.env.NODE_ENV;
Vue.prototype.$md5 = md5;
Vue.prototype.$store = store;
Vue.prototype.$moment  = moment;

Vue.config.productionTip = false
Vue.use(VueQriously);
Vue.use(loadingIndex);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
